import { Helpers } from '../../src/global/Helpers';
// Styles are now added via the map ID in the Google Cloud Console, SF account.
// import mapStylesJSON from './lightgraymap.json';
import { Loader } from "@googlemaps/js-api-loader"
import { MarkerClusterer } from '@googlemaps/markerclusterer';

export const Locations = (() => {
	'use strict';

	let map;
	let markers = [];

	const MAP_CONFIG = {
		center: { lat: -34.397, lng: 150.644 },
		zoom: 12,
		mapId: '3a486dcb54de5716',
		// styles: mapStylesJSON,
		streetViewControl: false,
	};


	const SVG_MARKER = window.btoa(
		'<svg xmlns="http://www.w3.org/2000/svg" fill="#B11F28" viewBox="0 0 240 240"><circle cx="120" cy="120" opacity=".6" r="70"/><circle cx="120" cy="120" opacity=".3" r="90"/><circle cx="120" cy="120" opacity=".2" r="110" /></svg>',
	);

	const renderer = {
		render: ({ position, count }) => {
			// Create a div element to hold the marker
			const markerElement = document.createElement('div');
			markerElement.style.width = '50px';
			markerElement.style.height = '50px';
			markerElement.style.backgroundImage = `url('data:image/svg+xml;base64,${SVG_MARKER}')`;
			markerElement.style.backgroundSize = 'cover';
			markerElement.style.display = 'flex';
			markerElement.style.justifyContent = 'center';
			markerElement.style.alignItems = 'center';
			// Create a span element to display the count
			const markerCount = document.createElement('span');
			markerCount.style.color = 'rgba(255,255,255,0.9)';
			markerCount.style.fontSize = '10px';
			markerCount.style.fontWeight = 'bold';
			markerCount.innerHTML = count;
			// Append the count to the marker
			markerElement.appendChild(markerCount);
	   
			// Return the marker element
		  	return new google.maps.marker.AdvancedMarkerElement({
				position,
				content: markerElement,
				zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
		  	});
		},
	};

	async function init() {
		// If there is no map element or no locations data, return
		if (!document.getElementById('locations-map') || typeof wsfLocations === 'undefined') return;
		// Load the map
		await initMap();
	}

	async function initMap() {
		// Load the Google Maps API
		const loader = new Loader({
			apiKey: "AIzaSyAw73Y1iq1OAfaE4SzudVqp8d8_qLNg3B4",
			version: "weekly",
		});
		
		// Then load the map
		loader.load().then(async () => {
			const { Map } = await google.maps.importLibrary('maps');
			const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
	
			map = new Map(document.getElementById('locations-map'), MAP_CONFIG);
			renderMarkers(AdvancedMarkerElement);
		});
	}

	function createMarker(AdvancedMarkerElement, position, location) {
		const markerHTML = document.createElement('div');
		markerHTML.innerHTML = '<div class="w-3 h-3 bg-red rounded-full ring-4 ring-[#FFE6D5]/60"></div>';
		markerHTML.className =
			'transition-expo w-6 h-6 flex flex-col justify-center items-center rounded-full border-2 border-red-accent/0 hover:border-red-accent/100 translate-y-1/2 cursor-pointer';

		const marker = new AdvancedMarkerElement({
			position,
			map,
			content: markerHTML,
		});

		marker.addListener('click', () => handleMarkerClick(marker, location));
		return marker;
	}

	function highlightActiveMarker(activeMarker) {
		markers.forEach((marker) => {
			marker.content.classList.remove('border-red-accent/100');
			marker.content.classList.add('border-red-accent/0');
		});
		activeMarker.content.classList.add('border-red-accent/100');
		activeMarker.content.classList.remove('border-red-accent/0');
	}

	function renderLocation(location) {
		const targetEl = document.getElementById('location-data');
		const template = document.getElementById('location-template');
		const clone = template.content.cloneNode(true);

		clone.querySelector('[data-image-container]').innerHTML = location.image;
		clone.querySelector('h3').textContent = location.title;
		clone.querySelector('h2').textContent = location.location;
		clone.querySelector('[data-content-container]').innerHTML = location.content;

		const linkEl = clone.querySelector('a');
		if (location.map_link) {
			linkEl.innerText = location.map_link.title;
			linkEl.setAttribute('href', location.map_link.url);
			linkEl.setAttribute('target', location.map_link.target);
			linkEl.setAttribute('aria-label', `${location.map_link.title} about ${location.title}`);
		} else {
			linkEl.remove();
		}

		targetEl.replaceChildren(clone);
	}

	function smoothZoomAndPan(position, zoom) {
		const currentZoom = map.getZoom();
		const steps = 20;
		const zoomStep = (zoom - currentZoom) / steps;

		function animate(step) {
			if (step < steps) {
				map.setZoom(currentZoom + zoomStep * step);
				map.panTo(position);
				requestAnimationFrame(() => animate(step + 1));
			} else {
				map.setZoom(zoom);
				map.panTo(position);
			}
		}

		animate(0);
	}

	// Update handleMarkerClick function
	function handleMarkerClick(marker, location) {
		smoothZoomAndPan(marker.position, 10);
		highlightActiveMarker(marker);
		renderLocation(location);
	}

	function renderMarkers(AdvancedMarkerElement) {
		const mapBounds = new google.maps.LatLngBounds();
		markers.length = 0; // Clear existing markers

		// Create markers in batches
		const batchSize = 100;
		const totalLocations = wsfLocations.length;

		function createBatch(startIndex) {
			const endIndex = Math.min(startIndex + batchSize, totalLocations);

			for (let i = startIndex; i < endIndex; i++) {
				const location = wsfLocations[i];
				const position = new google.maps.LatLng(location.map.lat, location.map.lng);

				const marker = createMarker(AdvancedMarkerElement, position, location);
				mapBounds.extend(position);

				if (i === 0) {
					map.setCenter(position);
					Helpers.toggleCSSclasses(marker.content, ['border-red-accent/100', 'border-red-accent/0']);
					renderLocation(location);
				}

				markers.push(marker);
			}

			if (endIndex < totalLocations) {
				requestAnimationFrame(() => createBatch(endIndex));
			} else {
				finishMarkerCreation();
			}
		}

		function finishMarkerCreation() {
			const markerClusterer = new MarkerClusterer({
				markers,
				map,
				renderer,
				maxZoom: 15,
			});

			map.fitBounds(mapBounds);
			// initialBounds = map.getBounds();

			// Add padding to the bounds
			const padding = { top: 50, right: 50, bottom: 50, left: 50 }; // Adjust these values as needed
			map.fitBounds(mapBounds, padding);
		}

		createBatch(0);
	}

	return { init };
})();
